import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ListaItem} from "../../../_models/lista-item";
import {ConfirmationService, SelectItem} from "primeng/api";
import {forkJoin} from "rxjs";
import {ListaService} from "../../../_services/lista.service";
import {NavService} from "../../../_services/_nav.service";
import {Table} from "primeng/table";
import {EstadoService} from "../../../_services/estado.service";
import {Estado} from "../../../_models/estado";
import {ValidacionesFacetec} from "../../../_models/validaciones-facetec";
import {ValidacionesFacetecService} from "../../../_services/validaciones-facetec.service";

@Component({
  selector: 'app-flujo-venta-atributos-validar-facetec',
  templateUrl: './flujo-venta-atributos-validar-facetec.component.html',
})
export class FlujoVentaAtributosValidarFacetecComponent implements OnInit {
  carEstados = true;
  cargando = true;
  submitted = false;
  formulario: FormGroup;
  columnas: any[] = [];
  pageActual: number = 0;
  @ViewChild('dt') tabla: Table;

  lisValidacionesFaceTodos: ListaItem[];
  lisValidacionesFace: SelectItem[] = [];
  lisCausaSolicitudesTodos: ListaItem[];
  lisCausaSolicitudes: SelectItem[] = [];
  lisEstadosTodos: Estado[] = [];
  lisEstados: SelectItem[] = [];
  validacionFacetec: ValidacionesFacetec;
  lisValidacionFacetec: ValidacionesFacetec[];
  listaCompleta: ValidacionesFacetec[];
  constructor(private navServicio: NavService,
              private conServicio: ConfirmationService,
              private lisService: ListaService,
              private estadoService: EstadoService,
              private valFacetec: ValidacionesFacetecService,
              private fb: FormBuilder
  ) { }

  ngOnInit() {
    forkJoin(this.lisService.getMasterDetails("ListasValidacionesFacetec"),
      this.lisService.getMasterDetails("ListasCausalesSolicitudes"),
      this.estadoService.listadoHabilitados(),
      this.valFacetec.listadoHabilitados(),
      this.valFacetec.listado()).subscribe( ([lisvalidaciones, liscausales, lisestados, lisValFacetec, lisCompleta]) => {
      this.lisCausaSolicitudesTodos = liscausales;
      this.lisValidacionesFaceTodos = lisvalidaciones;
      this.lisEstadosTodos = lisestados;
      this.lisValidacionFacetec = lisValFacetec;
      this.listaCompleta = lisCompleta;
      this.cargarCombos();
      this.cargarFormulario();
      this.carEstados = false;
      this.cargando = false;
      this.refrescar();
    });
    this.columnas = [];
    this.columnas = [
      { field: 'validacionFacetec', header: this.navServicio.buscarMensaje( 'ATRIBUTOSVALIDARFACETEC.LBL_ATRIBUTO' ), sort: false },
      { field: 'indicadorAnalizamos', header: this.navServicio.buscarMensaje( 'ATRIBUTOSVALIDARFACETEC.LBL_ANALIZAMOS' ), sort: false },
      { field: 'indicadorDigital', header: this.navServicio.buscarMensaje( 'ATRIBUTOSVALIDARFACETEC.LBL_DIGITAL' ), sort: false },
      { field: 'estado', header: this.navServicio.buscarMensaje( 'ATRIBUTOSVALIDARFACETEC.LBL_ESTADO' ), sort: false },
      { field: 'causal', header: this.navServicio.buscarMensaje( 'ATRIBUTOSVALIDARFACETEC.LBL_CAUSAL' ), sort: false },
      { field: 'Acciones', header: this.navServicio.buscarMensaje( 'ATRIBUTOSVALIDARFACETEC.LBL_ACCIONES' ), sort: false },
    ]
  }

  cargarCombos(){
    this.lisCausaSolicitudesTodos.map(s=>{
      this.lisCausaSolicitudes.push({label: s.nombre, value: s.idLista});
    });
    this.lisValidacionesFaceTodos.map(s=>{
      this.lisValidacionesFace.push({label: s.nombre, value: s.idLista, title: s.codigo});
    });
    this.lisEstadosTodos.map(s=>{
      this.lisEstados.push({label: s.nombre, value: s.idEstado, title: s.codigo});
    });
  }

  cargarFormulario(){
    this.formulario = this.fb.group( {
      idValidacionFacetec: [this.validacionFacetec? this.validacionFacetec.idValidacionFacetec: null],
      idValidaFacetec: [this.validacionFacetec? this.validacionFacetec.idValidaFacetec: null, Validators.required],
      idEstado: [this.validacionFacetec? this.validacionFacetec.idEstado: null, Validators.required],
      idCausal: [this.validacionFacetec? this.validacionFacetec.idCausal: null, Validators.required],
      nivelCoincidencia: [this.validacionFacetec? this.validacionFacetec.nivelCoincidencia: null],
      indicadorAnalizamos: [this.validacionFacetec? this.validacionFacetec.indicadorAnalizamos: false],
      indicadorDigital: [this.validacionFacetec? this.validacionFacetec.indicadorDigital: false],
      indicadorHabilitado: [this.validacionFacetec? this.validacionFacetec.indicadorHabilitado: true],
    });
  }

  get f(){
    return this.formulario.controls;
  }

  validarChecks(){
    if(!this.f.indicadorAnalizamos.value && !this.f.indicadorDigital.value){
      this.showMessage('LBL_INFORMACION', 'ATRIBUTOSVALIDARFACETEC.LBL_CHECKS')
      return false;
    }else{
      return true;
    }
  }

  validarMatchLevelVisible(){
    const buscar = this.lisValidacionesFace.find(s => s.title === 'MATHCLEVEL');
    if(buscar.value === this.f.idValidaFacetec.value){
      return true;
    }else{
      return false;
    }
  }

  validarMatchLevel(){
    const buscar = this.lisValidacionesFace.find(s => s.title === 'MATHCLEVEL');
    if(buscar.value === this.f.idValidaFacetec.value){
      if(this.f.nivelCoincidencia.value){
        return true;
      }else{
        return false
      }
    }else{
      return true;
    }
  }

  validarEstado(){
    if(this.f.indicadorDigital.value || this.f.indicadorAnalizamos.value){
      if(this.f.idEstado.value){
        return true;
      }else{
        return false;
      }
    }else{
      return true;
    }
  }

  validarCausal(){
    if(this.f.indicadorDigital.value || this.f.indicadorAnalizamos.value){
      if(this.f.idCausal.value){
        return true;
      }else{
        return false;
      }
    }else{
      return true;
    }
  }

  validarUnaSolaValidacion(){
    const buscar = this.lisValidacionFacetec.find(x => x.idValidaFacetec === this.f.idValidaFacetec.value);
    if(buscar && !this.validacionFacetec){
      this.showMessage('LBL_INFORMACION', 'ATRIBUTOSVALIDARFACETEC.MSG_YAEXISTE')
      return false;
    }else {
      return true;
    }
  }

  validar(){
    if(this.validarEstado() &&
    this.validarMatchLevel() &&
    this.validarCausal() &&
    this.validarUnaSolaValidacion() &&
    this.validarChecks()){
      return true;
    }else{
      return false;
    }
  }

  onSubmit(){
    this.submitted = true;
    if(this.formulario.valid && this.validar()){
      this.cargando = true;
      const buscar = this.listaCompleta.find(x => x.idValidaFacetec === this.f.idValidaFacetec.value && !x.indicadorHabilitado);
      if(buscar){
        this.f.idValidacionFacetec.setValue(buscar.idValidacionFacetec);
        this.f.indicadorHabilitado.setValue(true);
      }
      const registro = this.formulario.value;

      if(registro.idValidacionFacetec){
        this.valFacetec.actualizar(registro).subscribe(s=>{
          this.navServicio.setMesage( 2 );
          this.submitted = false;
          this.cargando = false;
          this.refrescar();
        }, error => {
          this.cargando = false;
          this.navServicio.setMesage( 3 );
        });
      }else{
        this.valFacetec.crear(registro).subscribe(s=> {
          this.navServicio.setMesage( 1 );
          this.submitted = false;
          this.cargando = false;
          this.refrescar();
        }, error => {
          this.cargando = false;
          this.navServicio.setMesage( 3 );
        });
      }
    }

  }

  regresar(dirty: boolean){
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'flujo-venta-validar-facetec',
        accept: () => {
          this.salir( null );
          this.refrescar();
        },
        reject: () => {
        }
      } );
    } else {
      this.salir( null );
      this.refrescar();
    }
  }

  refrescar(){
    this.carEstados = true;
    this.cargando = true;
    this.valFacetec.listadoHabilitados().subscribe(s => {
      this.lisValidacionFacetec = s;
      this.submitted = false;
      this.cargando = false;
      this.validacionFacetec = null;
      this.cargarFormulario();
      this.carEstados = false;
    });
    this.valFacetec.listado().subscribe(res => {
      this.listaCompleta = res;
    });
  }

  salir( mensaje: number ) {
    this.cargarFormulario();
    this.submitted = false;
    this.cargando = false;
    if ( mensaje !== null && mensaje !== undefined ) {
      this.navServicio.setMesage( mensaje );
    }
  }

  paginaActual(event: any) {
    this.pageActual = event.first;
  }

  editar(dato: ValidacionesFacetec){
    this.validacionFacetec = dato;
    this.submitted = false;
    this.cargarFormulario();
  }

  mensajeEliminar(dato: ValidacionesFacetec){
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'ATRIBUTOSVALIDARFACETEC.MSG_ELIMINAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'flujo-venta-validar-facetec',
      accept: () => {
        this.inhabilitar(dato);
      },
      reject: () => {
      }
    } );
  }

  inhabilitar(dato: ValidacionesFacetec){
    dato.indicadorHabilitado = false;
    this.valFacetec.actualizar(dato).subscribe(s => {
      this.refrescar();
    });
  }

  private showMessage( titulo: string, mensaje: string, severity: string = 'info' ) {
    this.navServicio.setMesage( 0, {
      severity: severity, summary: this.navServicio.buscarMensaje( titulo ),
      detail: this.navServicio.buscarMensaje( mensaje )
    } );
  }

}
